import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";

export default function Page404() {
  return (
    <div className="container py-5 my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-7 col-lg-5 text-center">
          <div className="empty-state-modern p-5">
            <div
              className="empty-state-icon"
              style={{ background: "var(--danger-light)", color: "var(--danger)" }}
            >
              <FaExclamationTriangle />
            </div>
            <h1 className="fw-extrabold mb-2" style={{ fontSize: "56px", color: "var(--text-main)" }}>
              404
            </h1>
            <h4 className="fw-bold mb-2">Page Not Found</h4>
            <p className="text-muted mb-4">
              The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
            <Link to="/" className="btn btn-primary px-4 py-3 fw-bold rounded-pill d-inline-flex align-items-center gap-2" style={{ background: "var(--primary)", border: "none" }}>
              <FaHome size={14} /> Back to Homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
